import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { WareHouseDto } from "../dtos/warehouse/wareHouseDto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/warehouse`;

export const getAllWarehouses = async () => {
  return await getData<ResponseDto<WareHouseDto[]>>(baseUrl);
};

export const getWarehouseList = async (
  searchText: String, 
  logicCenter: string
) => {
  return await getData<ResponseDto<WareHouseDto[]>>(`${baseUrl}/modal`, {
    params: {
      searchText: searchText || '',
      logicCenter : logicCenter || ''
    }
  });
};

export const getWarehouseManufactList = async (
  searchText: String, 
  logicCenter: string
) => {
  return await getData<ResponseDto<WareHouseDto[]>>(`${baseUrl}/modal/manufact`, {
    params: {
      searchText: searchText || '',
      logicCenter : logicCenter || ''
    }
  });
};
